import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import styles from './Homepage.module.css'

const MotionLink = motion(Link)

const Homepage = () => {
  return (
    <motion.div
      className={styles.layoutContainer}
      layout
    >
      <MotionLink
        to='/music'
        className={styles.container}
        layout
      >
        <motion.div
          className={styles.title}
          layout
        >
          MUSIC
        </motion.div>
      </MotionLink>

      <MotionLink
        to='/about'
        className={styles.container}
        layout
      >
        <motion.div
          className={styles.title}
          layout
        >
          ABOUT
        </motion.div>
        {/* 🔥 ANIMATED BORDER */}
        <motion.div
          className={styles.divider}
          initial={{ x: 0, y: 0 }}
          animate={{ x: 0, y: 0 }}
          exit={{
            x: window.innerWidth > 768 ? '100%' : 0,
            y: window.innerWidth <= 768 ? '100%' : 0,
          }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        />
      </MotionLink>
    </motion.div>
  )
}

export default Homepage
